export default "__VITE_ASSET__5OBBxxz1__"